export default __webpack_public_path__ + "static/media/Perk_4.9fdc22c4.png";